"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DEFAULT_SCROLL_HEIGHT = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _transforms = require("@nteract/transforms");

var Immutable = _interopRequireWildcard(require("immutable"));

var _output = _interopRequireDefault(require("./output"));

var DEFAULT_SCROLL_HEIGHT = 600;
exports.DEFAULT_SCROLL_HEIGHT = DEFAULT_SCROLL_HEIGHT;

var Display = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(Display, _React$PureComponent);

  function Display() {
    (0, _classCallCheck2["default"])(this, Display);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Display).apply(this, arguments));
  }

  (0, _createClass2["default"])(Display, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isHidden = _this$props.isHidden,
          outputs = _this$props.outputs,
          props = (0, _objectWithoutProperties2["default"])(_this$props, ["isHidden", "outputs"]);

      if (!isHidden) {
        return _react["default"].createElement("div", {
          className: "cell_display",
          style: {
            maxHeight: props.expanded ? "100%" : "".concat(DEFAULT_SCROLL_HEIGHT, "px"),
            overflowY: "auto"
          }
        }, outputs ? outputs.map(function (output, index) {
          return _react["default"].createElement(_output["default"], (0, _extends2["default"])({
            key: index,
            output: output
          }, props));
        }) : null);
      }

      return null;
    }
  }]);
  return Display;
}(_react["default"].PureComponent);

exports["default"] = Display;
(0, _defineProperty2["default"])(Display, "defaultProps", {
  transforms: _transforms.transforms,
  displayOrder: _transforms.displayOrder,
  isHidden: false,
  expanded: false,
  theme: "light",
  models: Immutable.Map()
});